import Resizer from 'react-image-file-resizer';

const resizeFile = (file: File): Promise<any> =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      400,
      400,
      'JPEG',
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      'file',
    );
  });

export default resizeFile;
